import { useSurveyProgress } from '@/api/quiz/useProgress'
import QuizLayout from '@/components/quiz/QuizLayout'
import { getCookie } from '@/helpers'
import { ISurvey } from '@/models'
import { Skeleton } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'

const QuizPage = () => {
  const [quiz, setQuiz] = useState<ISurvey>()
  const [startQuiz, setStartQuiz] = useState<boolean>()
  const [isWrongSurvey, setIsWrongSurvey] = useState<boolean>(false)
  const { quizId } = useParams()
  const { surveyProgress, surveyProgressIsLoading } = useSurveyProgress(quizId, quizId === getCookie('quiz_id'))

  useEffect(() => {
    document?.getElementById('container')?.scroll({ top: 0, behavior: 'smooth' })
    if (surveyProgress) {
      setQuiz(surveyProgress)
      setStartQuiz(true)
    }
  }, [surveyProgress])

  const setSurveyFromQuizComplete = () => {
    setStartQuiz(false)
    setQuiz(undefined)
    setIsWrongSurvey(false)
  }

  if (surveyProgressIsLoading) return <Skeleton active />

  if ((surveyProgress && startQuiz) || (!startQuiz && !surveyProgress) || isWrongSurvey) {
    return (
      <QuizLayout
        activeSurvey={quiz}
        setStartSurvey={(e: string) => setSurveyFromQuizComplete()}
        isWrongSurvey={isWrongSurvey}
      />
    )
  }
}

export default QuizPage
